export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7819.a012f91c.jpg";